module.exports = __webpack_public_path__ + "static/media/smart-mr-logo.daff2b7a.png";